export function isInView(element: HTMLElement) {
    const rect = element.getBoundingClientRect();
    return rect.top - 1 <= 0 && rect.bottom >= 0;
}
